import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../components/formInputs/button/Button';
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import { ValidationSchemaForPricingConfigurator } from './ValidationSchemaForPricingConfigurator';
import { getProductList } from '../../../redux/actions/rfqManagementApi';
import {
    getPricingConfigurator,
    pricingConfigurator,
    getPastPricingConfigurator,
} from '../../../redux/actions/userManagementApi';
import AuthContext from '../../../store/AuthContext';
import {
    getPastPricingRowKey,
    getPricingProductRowKey,
    PricingProductRow,
} from './PricingConfigurator.helpers';

const PricingConfigurator = (props) => {
    const ctx = useContext(AuthContext);
    const navigate = useNavigate();
    const { rfqMang, userMang } = useSelector((state) => {
        return state.app;
    });
    const [editIndex, setEditIndex] = useState(null);
    const [originalValues, setOriginalValues] = useState({});
    const [newRowIndexes, setNewRowIndexes] = useState([]);
    const orgUlid = ctx.userData?.user_organizations[0]?.organization_ulid;
    const [selectedProducts, setSelectedProducts] = useState([]);

    const dispatch = useDispatch();

    const initialPricingConfigurator = {
        company_name: userMang.pricingConfigurator?.company_name || '',
        sofr_rate: userMang.pricingConfigurator?.sofr_rate || null,
        products: userMang.pricingConfigurator?.products || [{ product_ulid: '', global_calorific_value: null }],
        ulid: userMang.pricingConfigurator?.ulid || '',
        productsOldDetails: userMang.pastPricingConfigurator,
    };

    const handleSubmit = (values, actions) => {
        const payload = {
            company_name: values.company_name || '',
            sofr_rate: values.sofr_rate || 0,
            products: values.products.map((product) => ({
                product_ulid: product.product_ulid,
                global_calorific_value: product.global_calorific_value || 0,
            })),
            ulid: values.ulid,
        };
        dispatch(pricingConfigurator(payload));
        setTimeout(() => {
            dispatch(getPastPricingConfigurator(orgUlid));
        }, 1000);
    };

    const handleProductChange = (e, index, setFieldValue) => {
        const value = e.target.value;
        const newSelectedProducts = [...selectedProducts];
        newSelectedProducts[index] = value;
        setSelectedProducts(newSelectedProducts);
        setFieldValue(`products[${index}].product_ulid`, value);
    };
    useEffect(() => {
        dispatch(getPastPricingConfigurator(orgUlid));
        dispatch(getPricingConfigurator());
    }, []);
    useEffect(() => {
        dispatch(getProductList());
    }, [dispatch]);

    useEffect(() => {
        const products = userMang.pricingConfigurator?.products || [];
        setSelectedProducts(products.map((_a) => _a.product_ulid));
    }, [userMang.pricingConfigurator?.products]);

    return (
        <div className='col-12'>
            <div className='col-12 px-5 mt-4'>
                <p className='font-dh4 font-semiBold text-start'>
                    <i className='bi bi-arrow-left me-3 cursor' onClick={() => navigate('/dashboard')}></i> Pricing
                    Configurator
                </p>
                <Formik
                    initialValues={initialPricingConfigurator}
                    onSubmit={(values, actions) => handleSubmit(values, actions)}
                    validationSchema={ValidationSchemaForPricingConfigurator}
                    enableReinitialize={userMang.pricingConfigurator?.ulid ? true : false}>
                    {(formikProps) => (
                        <Form>
                            <div className='col-12 bg-white radius5 box-shadow'>
                                <div className='bg-white radius8 p-3 py-4 text-start'>
                                    <div className='row'>
                                        <div className='col-4 mb-3'>
                                            <label className='form-label text-neutral-800 font-b3 mb-1'>
                                                Company Name
                                            </label>
                                            <Field type='text' name='company_name' className='form-control font-b2' />
                                            <ErrorMessage
                                                name='company_name'
                                                component='div'
                                                className='error-message font-b4 text-error-700'
                                            />
                                        </div>
                                        <div className='col-4 mb-3'>
                                            <label className='form-label text-neutral-800 font-b3 mb-1'>
                                                SOFR Rate %
                                            </label>
                                            <Field type='number' name='sofr_rate' className='form-control font-b2' />
                                            <ErrorMessage
                                                name='sofr_rate'
                                                component='div'
                                                className='error-message font-b4 text-error-700'
                                            />
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-8 mt-3'>
                                            <table className='table align-top table-hover text-start font-b2'>
                                                <thead>
                                                    <tr className='bg-neutral-200 font-semiBold'>
                                                        <th className='bg-transparent'>Product</th>
                                                        <th className='bg-transparent'>Global Calorific Value</th>
                                                        <th className='bg-transparent text-center'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='font-b2'>
                                                    <FieldArray name='products'>
                                                        {({ push, remove }) => (
                                                            <>
                                                                {formikProps.values?.products?.map((pro, index) => (
                                                                    <PricingProductRow
                                                                        key={getPricingProductRowKey(pro)}
                                                                        pro={pro}
                                                                        index={index}
                                                                        editIndex={editIndex}
                                                                        setEditIndex={setEditIndex}
                                                                        setOriginalValues={setOriginalValues}
                                                                        formikProps={formikProps}
                                                                        rfqMang={rfqMang}
                                                                        selectedProducts={selectedProducts}
                                                                        handleProductChange={handleProductChange}
                                                                        newRowIndexes={newRowIndexes}
                                                                        setNewRowIndexes={setNewRowIndexes}
                                                                        originalValues={originalValues}
                                                                        remove={remove}
                                                                        setSelectedProducts={setSelectedProducts}
                                                                    />
                                                                ))}
                                                                <div className='row m-0'>
                                                                    <div className='col-12 mt-4'>
                                                                        <div className='col-12 text-start'>
                                                                            <button
                                                                                className='hollow-secondary font-medium secondary-auto'
                                                                                type='button'
                                                                                onClick={() => {
                                                                                    push({
                                                                                        product_ulid: '',
                                                                                        global_calorific_value: '',
                                                                                    });
                                                                                    setNewRowIndexes([
                                                                                        ...newRowIndexes,
                                                                                        formikProps.values.products
                                                                                            .length,
                                                                                    ]);
                                                                                }}>
                                                                                Add Product{' '}
                                                                                <span className='sf-add'></span>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <p className='font-semiBold font-h1 pb-3 border-bottom px-3 mb-0 mt-4'>
                                            SOFR Rate Audit Log
                                        </p>
                                        <div className='col-8 mt-3'>
                                            <table className='table align-top table-hover text-start font-b2'>
                                                <thead>
                                                    <tr className='bg-neutral-200 font-semiBold'>
                                                        <th className='bg-transparent'>Updated by</th>
                                                        <th className='bg-transparent'>Old SOFR rate</th>
                                                        <th className='bg-transparent'>New SOFR rate</th>
                                                        <th className='bg-transparent'>Updated At</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='font-b2'>
                                                    <FieldArray name='productsDetails'>
                                                        {({ push, remove }) => (
                                                            <>
                                                                {userMang &&
                                                                    userMang.pastPricingConfigurator?.map(
                                                                        (pro, index) => (
                                                                            <tr key={getPastPricingRowKey(pro)} className='mt-2'>
                                                                                <td className='col-3'>
                                                                                    <span>{pro.user_name}</span>
                                                                                    
                                                                                </td>
                                                                                <td className='col-2'>
                                                                                    <span>
                                                                                        {pro.payload.old_soft_rate}
                                                                                    </span>
                                                                                    
                                                                                </td>
                                                                                <td className='col-2'>
                                                                                    <span>
                                                                                        {pro.payload.new_soft_rate}
                                                                                    </span>
                                                                                    
                                                                                </td>{' '}
                                                                                <td className='col-2'>
                                                                                    <span>
                                                                                        {new Date(pro.updated_at)
                                                                                            .toLocaleDateString('en-GB')
                                                                                            .replace(/\//g, '-')}
                                                                                    </span>
                                                                                    
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    )}
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 py-3 mb-4 mt-3 text-start'>
                                <Button type='primary-sm' btnType='submit'>
                                    Submit
                                </Button>
                                <span className='px-2'></span>
                                <Button type='hollow-gray-sm' onClick={() => navigate('/dashboard')}>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default PricingConfigurator;
